var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Input',{staticClass:"form-input",attrs:{"type":"password","password":"","value":_vm.value,"maxlength":"20","size":"large","placeholder":_vm.placeholder},on:{"input":_vm.handleInput,"on-focus":_vm.onFocus,"on-blur":_vm.onBlur,"on-enter":_vm.enterHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }